import React from 'react'
import classnames from 'classnames'

import {
  useFloorState,
  useIsParticipantCameraInFloor,
} from '../../../../firebase/hooks/useFloor'
import { useOverlayState } from '../../../../firebase/hooks/useOverlays'
import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useFullParticipantInfo } from '../../../../webrtc/webRTCRoom'

import './FloorCameraFeed.scss'

interface FloorCameraFeedProps {
  id: number
}

const FloorCameraFeed = ({ id }: FloorCameraFeedProps) => {
  const isParticipantCameraInFloor = useIsParticipantCameraInFloor(id)
  const participant = useFullParticipantInfo(id)
  const floor = useFloorState()
  const overlay = useOverlayState()

  if (!participant?.tracks.camera) return null

  return (
    <div
      className={classnames('participant-video-track', {
        hide: !isParticipantCameraInFloor,
      })}
    >
      <VideoTrack track={participant.tracks.camera} objectFit="cover" />
      {floor?.layout === 'panel' &&
        participant.isShowingTvCards &&
        !overlay && <div className="name-tag">{participant.name}</div>}
    </div>
  )
}

export { FloorCameraFeed }
